module.exports = __webpack_public_path__ + "static/media/sebastianCarrillo.cde17cea.jpg";